import { render, staticRenderFns } from "./mobConcact.vue?vue&type=template&id=474f0a5a&scoped=true&"
import script from "./mobConcact.vue?vue&type=script&lang=js&"
export * from "./mobConcact.vue?vue&type=script&lang=js&"
import style0 from "./mobConcact.vue?vue&type=style&index=0&id=474f0a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474f0a5a",
  null
  
)

export default component.exports